module.exports =   {
      initQuery: require('../methods/init-query'),
      initCustomFilters: require('../methods/init-custom-filters'),
      initOptions: require('../methods/init-options'),
      sortableClass: require('../methods/sortable-class'),
      sortableChevronClass: require('../methods/sortable-chevron-class'),
      display:require('../methods/display'),
      orderByColumn: require('../methods/order-by-column'),
      getHeading: require('../methods/get-heading'),
      addCustomColumns: require('../methods/add-custom-columns'),
      sortable: require('../methods/sortable'),
      display: require('../methods/display'),
      serverSearch: require('../methods/server-search'),
      initOrderBy: require('../methods/init-order-by'),
      initDateFilters: require('../methods/init-date-filters'),
      setPage: require('../methods/set-page'),
      initPagination: require('../methods/init-pagination'),
      filterable: require('../methods/filterable'),
      isTextFilter: require('../methods/is-text-filter'),
      isDateFilter: require('../methods/is-date-filter'),
      isListFilter: require('../methods/is-list-filter'),
      highlightMatch: require('../filters/highlight-matches'),
      formatDate: require('../filters/format-date'),
      hasDateFilters: require('../methods/has-date-filters'),
      applyFilters: require('../methods/apply-filters'),
      optionText: require('../filters/option-text'),
      render: require('../methods/render'),
      rowWasClicked:require('../methods/row-was-clicked'),
      setLimit: require('../methods/set-limit'),
      dispatch: require('../methods/dispatch'),
      toggleChildRow: require('../methods/toggle-child-row'),
      childRowTogglerClass: require('../methods/child-row-toggler-class'),
      sendRequest: require('../methods/send-request'),
      getResponseData: require('../methods/get-response-data')

  }





// WEBPACK FOOTER //
// ./~/vue-tables-2/lib/mixins/methods.js